<template>
	<div class="hello">
		<div class="mask" v-if="refundShow">
			<div class="refund_div" v-if="!isForm">
				<div class="close" @click="closeEvent()">
					<img src="../assets/image/close.png" alt="">
				</div>
				<div class="refund_title">
					<span>退款</span>
				</div>
				<div class="goods_list">
					<div class="zanwu" v-if="goodslist.length <= 0">
						<img src="../assets/image/norefund.png" alt="">
					</div>
					<div class="goods" v-for="(item,index) in goodslist" :key="index">
						<div class="select" @click="select(index)">
							<img v-if="!item.isActive" src="../assets/image/selects.png" alt="">
							<img v-else src="../assets/image/selects_active.png" alt="">
						</div>
						<div class="goods_pic">
							<img :src="item.spec_pic" alt="">
						</div>
						<div class="spec_title">
							<p class="title">{{item.goods_title}}</p>
							<p class="retitle">套餐：{{item.spec_name}}</p>
						</div>
					</div>
				</div>
				<div class="bottom" v-if="goodslist.length > 0">
					<div class="bottom_active">
						<div class="select_all" @click="allSelect()">
							<img v-if="!selectShow" src="../assets/image/selects.png" alt="">
							<img v-else src="../assets/image/selects_active.png" alt="">
						</div>
						<div class="all_title">
							<span>全选</span>
						</div>
						<div class="tui" @click="refund()">
							<span>退款</span>
						</div>
					</div>
				</div>
			</div>
			<!-- 申请退款表单 -->
			<div class="refundForm" v-else>
				<div class="close" @click="closeEvent()">
					<img src="../assets/image/close.png" alt="">
				</div>
				<div class="refund_top">
					<span>退款原因</span>
				</div>
				<div class="refund_auto">
					<div class="refund_goods">
						<div class="goods_list_refund" v-for="(item,index) in refundList" :key="index">
							<div class="goods_img">
								<img :src="item.spec_pic" alt="">
							</div>
							<div class="goods_title">
								<p>{{item.goods_title}}</p>
								<p class="pTwo">套餐：{{item.spec_name}}</p>
							</div>
							<div class="goods_num">
								<span>x{{item.goods_num}}</span>
							</div>
						</div>
					</div>
					<div class="form_label">
						<div class="label">
							<div class="left">
								<span>退款原因</span>
							</div>
							<div class="right">
								<div class="right_select">
									<el-select v-model="value" placeholder="请选择">
										<el-option v-for="(item,index) in options" :key="index" :label="item"
											:value="item">
										</el-option>
									</el-select>
								</div>
							</div>
						</div>
						<div class="label">
							<div class="left">
								<span>退款金额</span>
							</div>
							<div class="right">
								<div class="right_select">
									<div class="price_refund">
										<span>￥{{allPrice}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="label" v-if="this.orderType == 3 || this.orderType == 5">
							<div class="left">
								<span>快递公司</span>
							</div>
							<div class="right">
								<div class="right_select">
									<el-select v-model="expor" placeholder="请选择">
										<el-option v-for="(item,index) in express" :key="index" :label="item.name"
											:value="item.cid">
										</el-option>
									</el-select>
								</div>
							</div>
						</div>

						<div class="label" v-if="this.orderType == 3 || this.orderType == 5">
							<div class="left">
								<span>快递单号</span>
							</div>
							<div class="right">
								<div class="right_select">
									<div class="price_refund">
										<el-input v-model="refund_code"></el-input>
									</div>
								</div>
							</div>
						</div>

						<div class="label">
							<div class="left">
								<span>退款说明</span>
							</div>
							<div class="right">
								<div class="right_select">
									<div class="price_refund">
										<textarea v-model="content" class="text-area" value="" placeholder="" />
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
				<div class="form_submit" @click="refundSub">
					<span>立即提交</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			refundShow: {
				type: Boolean,
				default: false,
			},
			goodslist: {
				type: Array,
				default: []
			},
			orderType: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				goodslist: [],
				selectShow: false,
				isForm: false,
				refundList: [],
				options: [],
				express: [],
				expor: '',
				value: '',
				content: '',
				refund_code: '',
				allPrice: '0.00'

			}
		},
		created() {
			console.log('1111');
			// this.goodslist = JSON.parse(localStorage.getItem('orderGoods'));
			console.log(this.goodslist);

			this.$fetch('refund/reasonList').then(res => {
				if (res.code == 200) {
					this.options = res.data;
				}
			})
			this.$fetch('refund/expressList').then(res => {
				if (res.code == 200) {
					this.express = res.data;
				}
			})
		},
		mounted() {

		},
		computed: {
			// allPrice(){
			//   var str = this.refundList.reduce((count,item) => count + parseInt(item.spec_price),0).toFixed(2);
			//   return str
			// },
			params() {
				var arr = [];
				this.goodslist.forEach(item => {
					if (item.isActive) {
						arr.push(item.order_goods_id);
					}
				})

				return arr;
			}
		},
		methods: {
			closeEvent() {
				this.refundShow = false;
				this.isForm = false;
				this.refundList = [];
				this.selectShow = false;
				this.goodslist.forEach(item => {
					this.$set(item, 'isActive', false);
				})
				this.$emit('closeEvent', this.refundShow);
			},
			select(index) {
				this.goodslist[index].isActive = !this.goodslist[index].isActive;
				if (this.goodslist.findIndex(item => item.isActive === false) == -1) {
					this.selectShow = true;
				} else {
					this.selectShow = false;
				}
				
			},
			allSelect() {
				this.selectShow = !this.selectShow;
				this.goodslist.forEach(item => {
					if (this.selectShow) {
					
						this.$set(item,'isActive',true)
					} else {
						this.$set(item,'isActive',false)
					}
				})
			},
			refund() {
				
				// this.refundList.push(this.goodslist[index]);
				this.goodslist.forEach(item => {
					if(item.isActive){
						this.refundList.push(item);
					}
				})
				console.log(this.refundList,'撒大苏打撒 的撒');
				if (this.refundList.length <= 0) {
					this.$message.error('请选择商品');
					return
				}
				this.allPrice = this.refundList.reduce((count, item) => count + (item.goods_num * parseFloat(item.spec_price) + parseFloat(item.fee_price)), 0).toFixed(2)
				this.isForm = true;
				
			},
			refundSub() {
				let refund_type = 1;
				if (this.orderType == 5 || this.orderType == 3) {
					refund_type = 2;
				} else {
					refund_type = 1;
				}
				console.log(this.params);
				var data = {
					order_id: parseInt(this.$route.query.id),
					order_goods_id: this.params.toString(),
					cause: this.value,
					content: this.content,
					ship_code: this.refund_code,
					refund_type: refund_type,
					ship_cid: this.expor
				}
				this.$post('refund/apply', data).then(res => {
					if (res.code == 200) {
						this.$router.push({
							path: '/personal',
							query: {
								order_id: 1
							}
						})
					}
				})
			}
		}
	}
</script>

<style scoped="scoped">
	@import url("../assets/css/refund.css");
</style>



// WEBPACK FOOTER //
// src/components/refund.vue